import React, { useState } from "react";
import "./WitEarnHome.scss"
import PricingPlanCard from "../../components/PricingPlanCard/PricingPlanCard";
import { sortByOrderAscending } from "../../helper/helper";
const WitEarnHomePricing = ({ components, defaultPlan = "" }) => {
    const [selected, setSelected] = useState(defaultPlan.toUpperCase())

    const getComponents = (key, component) => {
        switch (component.ID) {
            case "HeaderText":
                return <div className="WitEarnHomePricing-header">
                    {component?.Props?.text}
                </div>
            case "HeaderSubText":
                return <div className="WitEarnHomePricing-subheader">
                    {component?.Props?.text}
                </div>
            case "WitEarnHomePricingPlanComponent":
                return <div className="WitEarnHomePricing-grid">
                    {component?.Data?.map((data, key) => {
                        return <PricingPlanCard data={data} key={key} selected={selected}
                            onClick={() => {
                                setSelected(data?.pricingHeader.toUpperCase())
                            }} />
                    })}
                </div>
            default:
                return <div />
        }

    }

    return (
        <div className="WitEarnHomePricing">
            {sortByOrderAscending(components).map((component, key) => {
                return getComponents(key, component)

            })}
        </div>
    )
}
export default WitEarnHomePricing